import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { CategoryItem } from './CategoryItem';

export type TCategoryItem = {
  children: TCategoryItem[];
  header: string;
  id: string;
  link: {
    url: string;
  };
  name: string;
  type: string;
  visible: boolean;
};

const SideMenuItem = ({
  categoryItem,
  isSidebar
}: {
  categoryItem: TCategoryItem;
  isSidebar?: boolean;
} & RouteComponentProps) => (
  <CategoryItem categoryItem={categoryItem} isSidebar={isSidebar} />
);

export default withRouter(SideMenuItem);
